import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Tooltip, Menu, MenuItem } from '@mui/material';
import HelpIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@components/IconButton';
import { track } from '@common/analytics';

const UtilityHeaderHelpMenu = () => {
  const history = useHistory();
  const [helpMenuAnchorEl, setHelpMenuAnchorEl] = useState(null);

  const openHelpMenu = event => {
    setHelpMenuAnchorEl(event.currentTarget);
  };

  const closeHelpMenu = () => {
    setHelpMenuAnchorEl(null);
  };

  const onClickHelpLink = () => {
    track('navigation', 'access-aware-v2-help-link', 'navigation:app-bar');
    window.open('https://support.eduphoria.net/', 'help', 'noreferrer');
  };

  const onClickAwareV2Help = () => {
    track('navigation', 'access-aware-v2-help-page', 'navigation:app-bar');
    history.push('/help');
  };

  return (
    <>
      <Tooltip title="Help Menu">
        <IconButton
          analytics={['navigation', 'access-help', 'navigation:app-bar']}
          aria-label="help menu"
          onClick={openHelpMenu}
          size="large"
        >
          <HelpIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="aware-help-menu"
        anchorEl={helpMenuAnchorEl}
        open={Boolean(helpMenuAnchorEl)}
        onClose={closeHelpMenu}
      >
        <MenuItem onClick={onClickHelpLink} component="button">
          Help Guide
        </MenuItem>
        <MenuItem onClick={onClickAwareV2Help} component="button">
          Aware Resources
        </MenuItem>
      </Menu>
    </>
  );
};

export default UtilityHeaderHelpMenu;
